import React from 'react'
import { Chip } from '@mui/material'
import { Supplier, SupplierOrigin } from '../../../interfaces/Supplier/Supplier'
import { Warehouse } from '../../../interfaces/Warehouse/Warehouse'
import { ProductOrigin } from '../../../interfaces/Producto/ProductOrigins'

export const getColumnsConfig = (productOrigins?: ProductOrigin[]) => [
  { key: 'supplierName' as keyof Supplier, title: 'Nombre' },
  { key: 'rutDniSupplier' as keyof Supplier, title: 'RUT/DNI' },
  {
    key: 'minDaysInBound' as keyof Supplier,
    title: 'Tolerancia en días de Recepción FEFO',
    render: (
      value: string | number | boolean | Warehouse[] | SupplierOrigin[]
    ) => {
      if (typeof value === 'number') {
        return `${value} días`
      }
      return 'N/A'
    }
  },
  {
    key: 'productOriginId' as keyof Supplier,
    title: 'Marca',
    render: (
      value: string | number | boolean | Warehouse[] | SupplierOrigin[],
      _row: Supplier
    ) => {
      return (
        productOrigins?.find((el) => el.productOriginId === value)?.name ||
        'Sin Marca'
      )
    }
  },
  {
    key: 'warehouses' as keyof Supplier,
    title: 'Almacenes',
    render: (
      _value: string | number | boolean | Warehouse[] | SupplierOrigin[],
      row: Supplier
    ) => {
      if (!row.warehouses || row.warehouses.length === 0) {
        return <span>Sin almacén</span>
      }

      return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
          {row.warehouses.map((warehouse, index) => (
            <Chip
              key={index}
              label={warehouse.warehouseName}
              size='small'
              variant='outlined'
            />
          ))}
        </div>
      )
    }
  },
  {
    key: 'active' as keyof Supplier,
    title: 'Activo',
    render: (
      value: string | number | boolean | Warehouse[] | SupplierOrigin[]
    ) => {
      return value ? 'Sí' : 'No'
    }
  }
]
